//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        planet: {
            type: Object
        }
    },

    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    },

    methods: {
        goToPlanet () {
            let weekRoute = this.$store.getters.getWeekRoute(this.planet.week);

            this.$router.push({
                name: weekRoute !== null ? weekRoute : this.planet.route
            });
        }
    }
};
